import 'cropperjs/dist/cropper.min.css';
import 'hint.css/hint.base.css';
import 'intl-tel-input/build/css/intlTelInput.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'normalize.css';
import 'primer-tooltips/index.scss';
import 'rc-slider/assets/index.css';
import 'react-table/react-table.css';
import 'simplelightbox/dist/simplelightbox.scss';
import 'stylesheets/tailwinds.scss';
import 'swiper/dist/css/swiper.css';

require.context(
  '../stylesheets/',
  true,
  /.*\.scss/,
);
